import { observer } from "mobx-react-lite";
import { FC } from "react";
import { FileUploadRejectedModalStore } from "@/components/modal/file-upload-rejected/file-upload-rejeted-modal-store";
import {
  MDSDialogSlotName,
  MDSDialogTextContent,
  MDSModalDialog,
  MDSText,
  MDSTextVariant,
} from "@/mds";

export interface FileUploadRejectedModalProps {
  store: FileUploadRejectedModalStore;
}

export const FileUploadRejectedModal: FC<FileUploadRejectedModalProps> = observer(({ store }) => {
  return (
    <MDSModalDialog isOpen={store.isOpen} handleClose={() => store.close()}>
      <MDSText slot={MDSDialogSlotName.Header} variant={MDSTextVariant.HeaderL}>
        Upload failed
      </MDSText>
      <MDSDialogTextContent slot={MDSDialogSlotName.Content}>
        <MDSText variant={MDSTextVariant.ParagraphS}>{store.errorSummary}</MDSText>
        <MDSText variant={MDSTextVariant.ParagraphS}>{store.errorMessage}</MDSText>
      </MDSDialogTextContent>
    </MDSModalDialog>
  );
});
